import { render, staticRenderFns } from "./SanityHeroModule.vue?vue&type=template&id=3c34555f"
import script from "./SanityHeroModule.vue?vue&type=script&lang=js"
export * from "./SanityHeroModule.vue?vue&type=script&lang=js"
import style0 from "./SanityHeroModule.vue?vue&type=style&index=0&id=3c34555f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports